import React from "react";
import {Moment} from "moment";
import {ConversationChannel, TranscriptAnalyticsRequest} from "../../../../../api/generated";
import {SelectOption} from "../../../../elements/select/SelectDropdown";
import {AnalyticsFilters} from "../components/AnalyticsFilters/AnalyticsFilters";
import styles from "./AnalyticsHeader.module.css";

interface AnalyticsHeaderProps {
    botOptions: SelectOption<string>[];
    request: TranscriptAnalyticsRequest;
    onAssistantChange: (publicBotIds: string[]) => void;
    onChannelChange: (channels: ConversationChannel[]) => void;
    onDateRangeChange: (start: Moment, end: Moment) => void;
    onReset: () => void;
}

export const AnalyticsHeader: React.FC<AnalyticsHeaderProps> = ({
    botOptions,
    request,
    onAssistantChange,
    onChannelChange,
    onDateRangeChange,
    onReset,
}) => {
    return <div className={styles.wrapper}>
        <span className={styles.title}>Analytics</span>
        <AnalyticsFilters
            botOptions={botOptions}
            request={request}
            onAssistantChange={onAssistantChange}
            onChannelChange={onChannelChange}
            onDateRangeChange={onDateRangeChange}
            onReset={onReset}
        />
    </div>;
};
